export default function matchAndReturn<TOption extends string | number | symbol, TOptionReturn>(
	option: TOption,
	options: {
		[P in TOption]: TOptionReturn;
	},
): TOptionReturn {
	return options[option];
}
